export default {
    formatShortDate: (date) => {
        return date;
    }
};
